import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    EmbeddedMenuRailInsetConstantType,
    EmbeddedMenuWidthsConstantType,
    EmbeddedMenuDynamicStyle,
    EmbeddedMenuWidths
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getSidebarMeasures
} from "../sidebar/stylesheet";

export const getEmbeddedMenuWidths = ({
    controlHeights,
    shapeConfigs,
    maxWidth,
    minWidth,
    spaces
}: EmbeddedMenuWidthsConstantType): EmbeddedMenuWidths => {
    return {
        minWidth: minWidth ?? controlHeights.large + spaces.spacingLg,
        maxWidth: maxWidth ?? shapeConfigs.drawerWidth
    };
};

export const getEmbeddedMenuRailInset = ({
    controlHeights,
    minWidth
}: EmbeddedMenuRailInsetConstantType): number => {
    return Math.max(0, (minWidth - controlHeights.large) / 2);
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        overflow: "hidden",
        display: "flex",
        height: "100%"
    },
    logoContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerSpacer: {
        width: "100%"
    },
    safeAreaView: {
        flex: 1
    },
    body: {
        flex: 1
    }
});

export const useStyles = ({
    backgroundColor,
    controlPaddings,
    controlHeights,
    shapeConfigs,
    isExpanded,
    maxWidth,
    minWidth,
    borders,
    colors,
    spaces
}: EmbeddedMenuDynamicStyle) => {
    const measures = getSidebarMeasures({
        controlPaddings,
        controlHeights,
        shapeConfigs,
        spaces
    });

    const railInset = getEmbeddedMenuRailInset({
        controlHeights,
        minWidth
    });

    const styles = {
        container: {
            backgroundColor: backgroundColor ? colors.project[backgroundColor] : colors.content.container.mid,
            borderColor: colors.content.border.subtle,
            borderEndWidth: borders.separator
        } as Mutable<ViewStyle>,
        body: {
            width: (isExpanded ? maxWidth : minWidth) - borders.separator
        } as Mutable<ViewStyle>,
        logoContainer: {
        } as Mutable<ViewStyle>,
        section: {
        } as Mutable<ViewStyle>
    };

    if(!isExpanded) {
        styles.section.marginHorizontal = railInset - measures.padding;

        styles.logoContainer.justifyContent = "center";
    }

    return styles;
};

export default stylesheet;
